module.exports = __webpack_public_path__ + "media/images/flags/it-b4f46de79fea4f007d09addd654d4e49.svg";